import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

import { useArabicSessionLanguage } from '@context/SessionSettingsContext'

import { Body2, Heading6 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { ArrowIcon } from '@ui/icons/Arrow.icon'

import { Box } from '@shared/components/Box'

import styles from './WalletSetupIndicator.module.scss'

export interface WalletSetupIndicatorProps {
  isButtonDisabled: boolean
  onSetupComplete: () => void
}

export function WalletSetupIndicator(props: WalletSetupIndicatorProps): JSX.Element {
  const { t } = useTranslation()
  const { onSetupComplete, isButtonDisabled } = props
  const isArabic = useArabicSessionLanguage()

  return (
    <div className={styles.container}>
      <Box textAlign='center'>
        <Heading6 medium>{t('Setting up your TICKMILL account')}</Heading6>
        <Body2>{t('Please wait a moment')}</Body2>
      </Box>

      <Box flex>
        <Button.Primary
          size='lg'
          fullWidth
          disabled={isButtonDisabled}
          loading={isButtonDisabled}
          iconRight={isArabic ? ArrowIcon.Left : ArrowIcon.Right}
          onClick={onSetupComplete}
        >
          {t('Next')}
        </Button.Primary>
      </Box>
    </div>
  )
}
